import { render, staticRenderFns } from "./EventWizard_EventCommunication.vue?vue&type=template&id=56ebc57a&scoped=true&"
import script from "./EventWizard_EventCommunication.vue?vue&type=script&lang=js&"
export * from "./EventWizard_EventCommunication.vue?vue&type=script&lang=js&"
import style0 from "./EventWizard_EventCommunication.vue?vue&type=style&index=0&id=56ebc57a&lang=scss&%2C=true&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ebc57a",
  null
  
)

export default component.exports